import xhr from '~/frontend/src/utilities/xhr';
import {
    DATACHANGEEVENTS_RELOAD
} from '~/frontend/src/constants';
import {Dispatch} from 'redux';


export type ReloadAction = {
    type : typeof DATACHANGEEVENTS_RELOAD;
};

/**
 * @memberOf! Actions
 *
 * @return {Promise<void>}
 */
export const reload = () => async ( dispatch : Dispatch ) : Promise<void> => {
    dispatch( {
        type: DATACHANGEEVENTS_RELOAD
    } );

    await xhr.post(
        `${BASE_URL}/api/dataChangeEvents/reload`,
        undefined,
        undefined,
        'global_non_masking',
        'reloadConfig',
        dispatch
    );
};
